import {
  AssetIdSchema,
  AssetSchema,
  ConceptIdSchema,
  ConceptSchema,
  LabelIdSchema,
  LabelSchema,
  ProjectIdSchema,
  ProjectSchema,
  RealmSchema,
  ViewIdSchema,
  ViewSchema,
  WorkspaceIdSchema,
  WorkspaceSchema,
} from "@storytell/types";
import z from "zod";

export const SyncSchema = z.object({
  concepts: z.record(ConceptIdSchema, ConceptSchema),
});
